import { marketStats, type MarketStat } from "@/data/marketStats";
import { cn } from "@/lib/utils";

export interface StatsStripProps {
  /** Default: `marketStats` (cada um com fonte primária linkada). */
  stats?: MarketStat[];
  className?: string;
}

/**
 * Faixa de estatísticas de mercado da home. Só apresenta: os números e as
 * fontes vêm de `src/data/marketStats.ts` — nunca número sem fonte.
 */
export function StatsStrip({ stats = marketStats, className }: StatsStripProps) {
  if (stats.length === 0) return null;

  return (
    <section
      aria-labelledby="market-stats-title"
      className={cn("border-y border-border bg-card", className)}
    >
      <div className="mx-auto max-w-[1180px] px-8 py-[30px] max-[900px]:px-5">
        <h2 id="market-stats-title" className="sr-only">
          O mercado em números
        </h2>
        <div className="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-6">
          {stats.map((s) => (
            <div key={s.label}>
              <div className="text-[30px] font-bold tracking-[-0.03em] text-primary">{s.value}</div>
              <p className="mt-1 text-[13.5px] leading-[1.5]">{s.label}</p>
              <a
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-1.5 inline-block text-[11.5px] text-muted-foreground underline underline-offset-2 hover:text-foreground"
              >
                Fonte: {s.source}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default StatsStrip;
